import { Grid, Paper, Title, Text, Group, Stack, Badge, Box, Skeleton } from "@mantine/core";
import { IconUsers, IconClock, IconCircleCheck, IconAlertTriangle } from "@tabler/icons-react";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useAuthContext } from "../../Hooks/UseAuthContext";











const Dashboard = () => {
    const { user } = useAuthContext();
    const [dashboardLoading, setDashboardLoading] = useState(true);

    const [dashboardData, setDashboardData] = useState(null);

    useEffect(() => {

        // ==========================================
        // FRONTEND API FUNCTION
        // ==========================================

        const getDashboardCounts = async () => {
            try {
                //setDashboardLoading(true);
                const response = await fetch("https://api.boompay.in/admin/dashboard-counts",
                    {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user}`,
                        }
                    }
                );

                const data = await response.json();

                if (response.status === 200) {
                    setDashboardData(data.dashboard);
                } else {
                    message.error(data.message);
                }
            } catch (error) {
                console.log(error);
                message.error("Failed to fetch dashboard data");
            } finally {
                setDashboardLoading(false);
            }
        };

        if (user) {
            getDashboardCounts();
        }

    }, [user])

    const dashboardCards = [
        {
            title: "Total Merchant Onboard",
            value: dashboardData?.onboarding?.total_onboarding || "0",
            growth: "+12% this month",
            status: "Active",
            icon: <IconUsers size={28} />,
            gradient:
                "linear-gradient(135deg, #1677ff 0%, #4096ff 100%)",
        },

        {
            title: "Pending Verification",
            value: dashboardData?.onboarding?.pending_onboarding || "0",
            growth: "+5 today",
            status: "Pending",
            icon: <IconClock size={28} />,
            gradient:
                "linear-gradient(135deg, #faad14 0%, #ffc53d 100%)",
        },

        {
            title: "Approved Merchants",
            value: dashboardData?.onboarding?.approved_onboarding || "0",
            growth: "+20 this week",
            status: "Success",
            icon: <IconCircleCheck size={28} />,
            gradient:
                "linear-gradient(135deg, #52c41a 0%, #73d13d 100%)",
        },

        {
            title: "Rejected Cases",
            value: dashboardData?.onboarding?.rejected_onboarding || "0",
            growth: "Needs review",
            status: "Alert",
            icon: <IconAlertTriangle size={28} />,
            gradient:
                "linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)",
        },
    ];

    return (
        <>
            <Grid>

                {dashboardCards.map((card, index) => (

                    <Grid.Col
                        key={index}
                        span={{ base: 12, sm: 6, md: 4, lg: 3 }}
                    >
                        <Skeleton visible={dashboardLoading} h="100%">
                            <Paper
                                withBorder
                                radius="xl"
                                p="xl"
                                shadow="sm"
                                h="100%"
                                style={{
                                    background: card.gradient,
                                    color: "white",
                                    position: "relative",
                                    overflow: "hidden",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    minHeight: "220px",
                                }}
                            >

                                <Group justify="space-between">

                                    <Stack gap={2}>

                                        <Text
                                            size="sm"
                                            c="rgba(255,255,255,0.8)"
                                        >
                                            {card.title}
                                        </Text>

                                        <Title order={1}>
                                            {card.value}
                                        </Title>

                                    </Stack>

                                    <Box
                                        style={{
                                            width: 55,
                                            height: 55,
                                            borderRadius: "16px",
                                            background:
                                                "rgba(255,255,255,0.15)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {card.icon}
                                    </Box>

                                </Group>

                                <Group justify="space-between" mt="xl">

                                    <Text
                                        size="sm"
                                        c="rgba(255,255,255,0.8)"
                                    >
                                        {card.growth}
                                    </Text>

                                    <Badge
                                        variant="light"
                                        color="white"
                                    >
                                        {card.status}
                                    </Badge>

                                </Group>

                            </Paper>
                        </Skeleton>


                    </Grid.Col>

                ))}

            </Grid>

        </>
    );
}
export default Dashboard;